import {
  Component,
  ChangeDetectionStrategy,
  inject,
  input,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { toSignal } from '@angular/core/rxjs-interop';
import { IconComponent } from '@gains-com/ui-angular';
import { UserViewService } from '../../../../core/view-states/user-view.service';
import { DecimalPipe } from '../../../../pipes/decimal.pipe.js';

@Component({
  selector: 'app-redemption-dialog-header',
  imports: [MatIconButton, IconComponent, DecimalPipe],
  templateUrl: './redemption-dialog-header.component.html',
  styleUrl: './redemption-dialog-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedemptionDialogHeaderComponent {
  private readonly _userView = inject(UserViewService);

  headerGap = input<number>(8);
  step = input<number>(0);
  steps = input<number>(4);
  stepColor = input<'pending' | 'created' | 'complete' | 'failed' | 'blocked'>(
    'complete'
  );
  hideBack = input<boolean>(false);
  hideClose = input<boolean>(false);
  hideBalance = input<boolean>(false);
  hideSteps = input<boolean>(false);
  title = input<string | undefined>();
  subtitle = input<string | undefined>();

  close = output<void>();
  back = output<void>();

  user = toSignal(this._userView.state$);

  boxes = Array(this.steps()).fill(null);
}
